import countryCodes from 'common/services/countryCodes.json';

interface CountryCode {
	name: string;
	dial_code: string;
	code: string;
	flag: string;
}

export const getCountryCode = (phoneNumber: string): CountryCode | null => {
	if (!phoneNumber) {
		return null;
	}
	let country: CountryCode | null = null;
	let i = 1;
	while (country === null || i < phoneNumber.length) {
		// eslint-disable-next-line no-loop-func
		const result = countryCodes.find((e: CountryCode) => e.dial_code === phoneNumber.slice(0, i));
		if (result) {
			country = result;
		}
		i++;
	}

	// Åland and Finland share the same dial code, and this function returns Åland
	// instead of Finland due to the order in which they are in the countryCodes.json file.
	// Since the majority of our customers are in Finland, it's probably better to manually adjust
	// this to reduce confusion that'd be caused by the Åland flag in the phone number picker.
	if (country.code === 'AX') {
		return {
			name: 'Finland',
			dial_code: '+358',
			code: 'FI',
			flag: '🇫🇮',
		};
	}
	return country;
};
